<template>
  <v-card class="com-pc-card no-gutters tm-srch-list">
    <v-row class="com-pc-card-header">
      <span class="com-pc-card-title mb-1">観測所検索</span>
      <v-spacer></v-spacer>
      <v-btn text icon small color="white" @click="closeSrchDlg">
        <v-icon class="mb-1">highlight_off</v-icon>
      </v-btn>
    </v-row>
    <div class="card_content">
      <div class="search-box">
        <!-- 検索条件 -->
        <v-form ref="form" @submit.prevent>
          <v-container class="serach-keyword pa-0">
            <v-row no-gutters>
              <v-col class="box-keyword pa-0">
                <v-text-field
                  v-model="searchWord"
                  :rules="[
                    rule.keyword,
                    rule.noSlash,
                    rule.noDot,
                    rule.noQuotation,
                    rule.noPercent,
                    rule.noAnd,
                    rule.noQuestion,
                    rule.noBackSlash,
                    rule.noComma,
                  ]"
                  clearable
                  clear-icon="cancel"
                  class="text-keyword ml-2"
                  label="キーワード"
                  placeholder="検索ワードを入力してください"
                  @keyup.enter="keyboardEvent"
                  autofocus
                ></v-text-field>
              </v-col>
              <v-col class="box-target pa-0">
                <v-select
                  v-model="selectedSrchTarget"
                  :rules="[rule.target]"
                  :items="srchTarget"
                  label="検索対象"
                  small-chips
                  multiple
                  class="ml-2"
                >
                  <template v-slot:prepend-item>
                    <v-list-item dense ripple @click="TargetToggle">
                      <v-list-item-action>
                        <v-icon
                          :color="
                            selectedSrchTarget.length > 0
                              ? 'indigo darken-4'
                              : ''
                          "
                          >{{ targetIcon }}</v-icon
                        >
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>全て選択</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-select>
              </v-col>
              <v-col class="box-tmKind pa-0">
                <v-select
                  v-model="selectedTmKind"
                  :rules="[rule.itmKndCd]"
                  :items="tmKind"
                  small-chips
                  label="観測種別"
                  multiple
                  class="ml-2"
                >
                  <template v-slot:prepend-item>
                    <v-list-item dense ripple @click="tmToggle">
                      <v-list-item-action>
                        <v-icon
                          :color="
                            selectedTmKind.length > 0 ? 'indigo darken-4' : ''
                          "
                          >{{ tmIcon }}</v-icon
                        >
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>全て選択</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-select>
              </v-col>
              <v-col class="box-search pa-0">
                <v-btn
                  outlined
                  :loading="searchStatus === 2"
                  :disabled="
                    !checkSearchWord() ||
                      selectedSrchTarget.length === 0 ||
                      selectedTmKind.length === 0 ||
                      searchStatus === 2
                  "
                  color="black"
                  @click="obsSearch()"
                  class="ml-4"
                >
                  <v-icon left>search</v-icon>
                  <span>検索</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </div>
      <!-- 検索結果件数 -->
      <div v-show="listCount >= 50 && searchStatus === 3" class="listCount">
        検索結果が{{ listCount }}件あります。検索条件を絞ってください。
      </div>
      <div v-show="!isAccessOver && listCount === '0' && searchStatus === 3" class="listCount">
        対象となるデータはありません。
      </div>
      <div v-show="isAccessOver && searchStatus === 3" class="listCount">
        ただいま、検索機能の利用が集中しております。<br>
        サーバー負荷が軽減されると、検索できるようになります。
        しばらく時間を置いてから、再度お試しください。
      </div>
      <!-- 検索結果一覧 -->
      <v-list dense class="pa-0">
        <v-list-item class="pa-0">
          <v-list-item-content class="pa-0">
            <v-row no-gutters class="list-head">
              <v-col cols="3" class="obs-nm pa-0" style="max-width: 350px;">{{
                text.obsNm
              }}</v-col>
              <v-col
                cols="2"
                md="1"
                class="rsys-nm pa-0"
                style="max-width: 140px;"
                >{{ text.rsysNm }}</v-col
              >
              <v-col
                cols="2"
                md="1"
                class="rvr-nm pa-0"
                style="max-width: 140px;"
                >{{ text.rvrNm }}</v-col
              >
              <v-col cols="5" class="obs-adr pa-0" style="max-width: 680px;">{{
                text.obsAdr
              }}</v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <div class="rslt-box" v-show="searchStatus === 3">
        <div class="rslt-list">
          <v-list dense class="pa-0">
            <v-list-item
              v-for="(item, index) in dispList"
              :key="index"
              class="list-item pa-0"
              @click="openObsDetail(item)"
            >
              <v-list-item-content class="pa-0">
                <v-row no-gutters class="pa-2">
                  <v-col cols="3" class="pa-0" style="max-width: 350px;">
                    <div style="display:flex; align-items:center;">
                      <img class="icon-size" :src="getIcon(item)" />
                      <span>{{ item.obsNm }}</span>
                    </div>
                  </v-col>
                  <v-col
                    cols="2"
                    md="1"
                    class="pa-0"
                    style="max-width: 140px;"
                    >{{ item.rsysNm }}</v-col
                  >
                  <v-col
                    cols="2"
                    md="1"
                    class="pa-0"
                    style="max-width: 140px;"
                    >{{ item.rvrNm }}</v-col
                  >
                  <v-col cols="5" class="pa-0" style="max-width: 680px;">{{
                    item.adr
                  }}</v-col>
                </v-row>
                <v-divider></v-divider>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
/**
 * 川の防災情報 [PC]観測所検索カード
 * TmSearchList.vue
 * @author LIS
 */
import mixin from "./../../../lib/mixin.js";
import Util from "./../../../lib/util.js";

export default {
  name: "tm-search-list",
  mixins: [mixin],
  data() {
    return {
      // 検索キーワード
      searchWord: "",
      // 並び替えされた一覧
      dispList: [],
      // 検索結果件数
      listCount: null,
      rule: {
        keyword: (value) => !!value || "検索ワードは1文字以上入力してください",
        target: (value) =>
          value.length !== 0 || "検索対象は1つ以上選択してください",
        itmKndCd: (value) =>
          value.length !== 0 || "観測種別は1つ以上選択してください",
        noSlash: (value) =>
          !String(value).match(/\//) ||
          '"/"は検索ワードに含めることはできません',
        noDot: (v) =>
          !String(v).match(/\./) || '"."は検索ワードに含めることはできません',
        noQuotation: (v) =>
          !String(v).match(/"|”/) || '"”"は検索ワードに含めることはできません',
        noPercent: (v) =>
          !String(v).match(/%|％/) || '"%"は検索ワードに含めることはできません',
        noAnd: (v) =>
          !String(v).match(/&|＆/) || '"&"は検索ワードに含めることはできません',
        noQuestion: (v) =>
          !String(v).match(/\?|？/) ||
          '"?"は検索ワードに含めることはできません',
        noBackSlash: (v) =>
          !String(v).match(/\\/) || '"\\"は検索ワードに含めることはできません',
        noComma: (v) =>
          !String(v).match(/,/) || '","は検索ワードに含めることはできません',
      },
      // 検索対象
      srchTarget: [
        {
          value: "obsNm",
          text: "観測所名",
        },
        {
          value: "rsysNm",
          text: "水系名",
        },
        {
          value: "rvrNm",
          text: "河川名",
        },
        {
          value: "obsAdr",
          text: "所在地",
        },
      ],
      selectedSrchTarget: ["obsNm", "rsysNm", "rvrNm", "obsAdr"],
      // 観測種別
      tmKind: [
        {
          value: 4,
          text: "水位観測",
        },
        {
          value: 300,
          text: this.$store.state.app.config.replaceNameConfig.swstg,
        },
        {
          value: 7,
          text: "ダム諸量",
        },
        {
          value: 1,
          text: "雨量",
        },
        {
          value: 6,
          text: "水質",
        },
        {
          value: 12,
          text: "海岸",
        },
        {
          value: 3,
          text: "積雪深",
        },
        {
          value: 100,
          text: "カメラ",
        },
      ],
      selectedTmKind: [4, 300, 7, 1, 6, 12, 3, 100],
      /** 文字列リソース */
      text: {
        obsNm: "観測所名",
        rsysNm: "水系名",
        rvrNm: "河川名",
        obsAdr: "所在地",
      },
    };
  },
  computed: {
    allTarget() {
      return this.selectedSrchTarget.length === this.srchTarget.length;
    },
    partialTarget() {
      return this.selectedSrchTarget.length > 0 && !this.allTarget;
    },
    allTm() {
      return this.selectedTmKind.length === this.tmKind.length;
    },
    partialTm() {
      return this.selectedTmKind.length > 0 && !this.allTm;
    },
    targetIcon() {
      if (this.allTarget) {
        return "check_box";
      }
      if (this.partialTarget) {
        return "indeterminate_check_box";
      }
      return "check_box_outline_blank";
    },
    tmIcon() {
      if (this.allTm) {
        return "check_box";
      }
      if (this.partialTm) {
        return "indeterminate_check_box";
      }
      return "check_box_outline_blank";
    },
    /**
     * 検索結果一覧
     */
    rsltObsSearchList: {
      get() {
        return {
          rsltObsList: this.$store.state.search.rsltObsList,
          rsltObsCnt: this.$store.state.search.rsltObsCnt,
        };
      },
    },
    /**
     * 大量アクセス判定
     */
    isAccessOver: {
      get() {
        return this.$store.state.search.isAccessOver;
      },
    },
    /** 対象日時 */
    appTimeRound: {
      get() {
        return Util.formatDate(this.$store.state.app.appTimeRound);
      },
    },
    /** 検索状態 */
    searchStatus: {
      get() {
        return this.$store.state.search.searchStatus;
      },
    },
    /**
     * 水防団モード
     */
    isFldCtl: {
      get() {
        return this.$store.getters["app/isFldCtl"];
      },
    },
  },
  watch: {
    // 観測所検索一覧
    rsltObsSearchList() {
      this.dispList = this.rsltObsSearchList.rsltObsList;
      this.listCount = this.rsltObsSearchList.rsltObsCnt;
    },
  },
  methods: {
    /** 観測所検索ダイアログを閉じる */
    closeSrchDlg() {
      this.$store.commit(
        "search/setShowSrchDlg",
        !this.$store.state.search.showSrchDlg
      );
    },
    keyboardEvent(e) {
      if (e.which === 13) {
        // キーワード文字列が空の場合実行しない
        if (
          !this.searchWord ||
          !Object.keys(this.selectedSrchTarget).length ||
          !Object.keys(this.selectedTmKind).length
        )
          return;
        this.obsSearch();
      }
    },
    TargetToggle() {
      this.$nextTick(() => {
        if (this.allTarget) {
          this.selectedSrchTarget = [];
        } else {
          let list = this.srchTarget.map((obj) => obj.value);
          this.selectedSrchTarget = list.slice();
        }
      });
    },
    tmToggle() {
      this.$nextTick(() => {
        if (this.allTm) {
          this.selectedTmKind = [];
        } else {
          let list = this.tmKind.map((obj) => obj.value);
          this.selectedTmKind = list.slice();
        }
      });
    },
    obsSearch() {
      // 検索ワードエラーの場合は検索を実施しない
      if (this.checkSearchWord()) {
        setTimeout(() => {
          this.$store.dispatch("search/getRsltObsList", {
            keyword: this.searchWord,
            targets: this.selectedSrchTarget,
            obsType: this.selectedTmKind,
            appTime: this.appTimeRound,
            deviceSb: this.$store.state.app.mode,
            fcFlg: this.$store.getters["app/isFldCtl"],
          });
        }, 500);
      }
    },
    /** 検索ワードチェック */
    checkSearchWord() {
      if (
        this.rule.keyword(this.searchWord) == true &&
        this.rule.noSlash(this.searchWord) == true &&
        this.rule.noDot(this.searchWord) == true &&
        this.rule.noQuotation(this.searchWord) == true &&
        this.rule.noPercent(this.searchWord) == true &&
        this.rule.noAnd(this.searchWord) == true &&
        this.rule.noQuestion(this.searchWord) == true &&
        this.rule.noBackSlash(this.searchWord) == true &&
        this.rule.noComma(this.searchWord) == true
      ) {
        return true;
      }
      return false;
    },
    // 詳細画面遷移
    openObsDetail(item) {
      const obsdata = item;
      if (obsdata.itmkndCd === "300") {
        // 危機管理型水位計情報を設定
        this.$store.commit("Swin/setSelectedSwParam", {
          swofcCd: Number(obsdata.ofcCd),
          itmkndCd: Number(obsdata.itmkndCd),
          swobsCd: Number(obsdata.obsCd),
        });
      } else if (obsdata.itmkndCd === "100") {
        let itmkndCd = 100;
        if (obsdata.sysId === 1) {
          itmkndCd = 200;
        }
        // カメラ情報を設定
        this.$store.commit("Telemeter/setSelectedTmParamScam", {
          itmkndCd: itmkndCd,
          scamId: Number(obsdata.keyCd),
          ownCd: Number(obsdata.ownCd),
          sysCamId: Number(obsdata.sysCamId),
        });
      } else {
        // 選択中テレメータ情報を設定
        this.$store.commit("Telemeter/setSelectedTmParam", {
          ofcCd: Number(obsdata.ofcCd),
          itmkndCd: Number(obsdata.itmkndCd),
          obsCd: Number(obsdata.obsCd),
        });
      }
      // 画面遷移
      if (obsdata.itmkndCd === "100") {
        this.routerPushTmScam("/pc/tm");
        this.$store.commit("app/setPcPanelModeContent", "tmObs");
      } else if (obsdata.itmkndCd === "300") {
        this.routerPushTmSw("/pc/tm");
        this.$store.commit("app/setPcPanelModeContent", "tmObs");
      } else {
        this.routerPushTm("/pc/tm");
        this.$store.commit("app/setPcPanelModeContent", "tmObs");
      }
      this.closeSrchDlg();
    },
    /**
     * 観測所アイコンの取得
     */
    getIcon(item) {
      // 平常
      var icon;
      // 水位観測所
      if (item.itmkndCd === "4") {
        // 平常時
        icon = "/kawabou/img/obs_icons/obs_water_normal.svg";
        if (
          typeof item.stgCcd !== "undefined" &&
          (item.stgCcd >= 128 || item.stgCcd == null)
        ) {
          // 欠測
          icon = "/kawabou/img/obs_icons/obs_water_missing.svg";
        } else if (item.stgOvlvl === 90) {
          // 氾濫発生
          icon = "/kawabou/img/obs_icons/obs_water_flood.svg";
        } else if (
          item.rsrvStg === null &&
          item.warnStg === null &&
          item.spclWarnStg === null &&
          item.dngStg === null
        ) {
          // 基準水位未設定
          icon = "/kawabou/img/obs_icons/obs_water_notset.svg";
        } else if (item.stgOvlvl === 80 || item.stgOvlvl === 70) {
          // 氾濫危険水位超過
          icon = "/kawabou/img/obs_icons/obs_water_danger.svg";
        } else if (item.stgOvlvl === 60 || item.stgOvlvl === 50) {
          // 避難判断水位超過
          icon = "/kawabou/img/obs_icons/obs_water_refuge.svg";
        } else if (
          item.stgOvlvl === 40 ||
          item.stgOvlvl === 30 ||
          item.stgOvlvl === 20
        ) {
          // 氾濫注意水位超過
          icon = "/kawabou/img/obs_icons/obs_water_caution.svg";
        } else if (item.stgOvlvl === 10 && this.isFldCtl) {
          // 水防団待機水位超過
          icon = "/kawabou/img/obs_icons/obs_water_fldctl.svg";
        }
      }
      // 危機管理型水位観測所
      else if (item.itmkndCd === "300") {
        // 平常時
        icon = "/kawabou/img/obs_icons/obs_swstg_normal.svg";
        if (
          typeof item.swstgCcd !== "undefined" &&
          (item.swstgCcd >= 128 || item.swstgCcd == null)
        ) {
          // 観測値が取得出来ない場合、内部的に内容コード160が入る
          icon = "/kawabou/img/obs_icons/obs_swstg_missing.svg";
        } else if (item.swstgOvlvl === 90) {
          // 氾濫開始水位超過
          icon = "/kawabou/img/obs_icons/obs_swstg_flood.svg";
        } else if (item.swstgOvlvl === 80) {
          // 危険水位超過
          icon = "/kawabou/img/obs_icons/obs_swstg_danger.svg";
        } else if (item.swstgOvlvl === 30) {
          // 観測開始水位超過
          icon = "/kawabou/img/obs_icons/obs_swstg_start.svg";
        }
      }
      // ダム観測所
      else if (item.itmkndCd === "7") {
        icon = "/kawabou/img/obs_icons/obs_dam.svg";
      }
      // 雨量観測所
      else if (item.itmkndCd === "1") {
        icon = "/kawabou/img/obs_icons/obs_rain.svg";
      }
      // 水質観測所
      else if (item.itmkndCd === "6") {
        icon = "/kawabou/img/obs_icons/obs_quality.svg";
      }
      // 海岸観測所
      else if (item.itmkndCd === "12") {
        icon = "/kawabou/img/obs_icons/obs_sea.svg";
      }
      // 積雪観測所
      else if (item.itmkndCd === "3") {
        icon = "/kawabou/img/obs_icons/obs_snow.svg";
      }
      // 河川カメラ
      else if (item.itmkndCd === "100") {
        icon = "/kawabou/img/obs_icons/obs_cctv_river.svg";
      }

      return icon;
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-size {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}
.tm-srch-list {
  display: flex;
  flex-direction: column;
  width: 90%;
  height: 85%;
  overflow-x: hidden;
  .card_content {
    padding: 16px;
    display: flex;
    flex-direction: column;
    height: 100%;
    .search-box {
      display: flex;
      width: 100%;
      .box-keyword {
        min-width: 300px;
        max-width: 300px;
        margin-bottom: 4px;
        .text-keyword {
          font-size: 0.8rem;
          align-items: flex-end;
          ::placeholder {
            color: #e93838;
          }
        }
      }
      .box-target {
        min-width: 430px;
        max-width: 430px;
      }
      .box-tmKind {
        min-width: 600px;
        max-width: 600px;
      }

      .box-search {
        display: flex;
        align-items: center;
        min-width: 80px;
      }
    }
    .listCount {
      font-size: 0.9rem;
      color: #e93838;
    }
    .list-head {
      padding: 8px;
      font-size: 0.8rem;
      border-bottom: 1px solid #ddd;
      color: rgba(0, 0, 0, 0.6);
      display: flex;
    }
    .rslt-box {
      position: relative;
      height: 100%;
      .rslt-list {
        position: absolute;
        overflow-x: hidden;
        overflow-y: auto;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        .list-item {
          height: 100%;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
